"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenNativeInput = void 0;
var core_1 = require("../core");
exports.HiddenNativeInput = core_1.styled('input', {
    outline: 'none',
    position: 'absolute',
    transform: 'scale(0, 0)',
});
